import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { useRouter } from '../../hooks/useRouter.js';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { RichText } from '../../ui-kit/RichText/RichText.js';
import { UniBlock } from '../../UniBlock/UniBlock.js';
import { style } from '../../utils/style.js';
import { Headline } from '../Headline/Headline.js';
import { renderDefaultItem } from './renderDefaultItem.js';
import { ReportDialogButton } from './RepordDialogButton.js';
const linkColumnsModeStyleMap = {
    double: 'sm:flex-wrap sm:flex-row',
    single: 'sm:flex-col',
};
export const LinkDocs = UniBlock(({ className = '', title, description, align = 'text-center', documents, icon = { icon: 'DocIcon' }, columnsMode = 'double', ...rest }) => {
    const router = useRouter();
    return (_jsxs(BlockWrapper, { className: style('space-y-lg', className), defaultPadding: "p-6xl", ...rest, children: [_jsx(Headline, { title: title, description: description, align: align, headlineVersion: "M", as: "h2", isEmbedded: true }), documents?.length ? (_jsx("div", { className: style('grid gap-xl', columnsMode === 'double' ? '@md:grid-cols-2' : 'grid-cols-1', linkColumnsModeStyleMap[columnsMode]), role: "list", children: documents.map(renderLinkDocItem(router, icon)) })) : null] }));
});
const renderLinkDocItem = (router, icon) => (docBlockDef, i) => {
    const docType = docBlockDef?.docType;
    if (docType === '') {
        return null;
    }
    if ('reportSource' in docBlockDef && docBlockDef?.reportSource?.__html) {
        return renderModalItem(docBlockDef, i);
    }
    return renderDefaultItem(router, icon)(docBlockDef, i);
};
const renderModalItem = (props, i) => {
    const commonProps = {
        text: props.text,
        target: props.target,
        __html: props.reportSource?.__html,
    };
    return props.reportSource?.__html && props.text ? (_jsxs("div", { role: "listitem", children: [_jsx(ReportDialogButton, { ...commonProps, href: isLinkDoc(props) ? props?.href : props?.attachment?.src }), _jsx(RichText, { __html: props?.__html })] }, String(i))) : null;
};
const isLinkDoc = (data) => 'href' in data;
//# sourceMappingURL=LinkDocs.js.map